export enum AendringsbekendtgoerelseSetting {
  IKKE_AENDRINGSBEKENDTGOERELSE = 0,
  AENDRINGSBEKENDTGOERELSE_BLANK = 1,
  AENDRINGSBEKENDTGOERELSE_EFORMS = 2
}
